import React from 'react';
import Modal from 'react-modal';

import { AiFillCloseCircle } from 'react-icons/ai';

export const VideoModal = ({ isOpen, closeModal }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} contentLabel='Modal'>
      <div className='d-flex flex-column'>
        <AiFillCloseCircle className='closeButton' onClick={closeModal} />
        <iframe
          className='videoFrame'
          src='https://www.youtube.com/embed/twSmyZ5UCwA?autoplay=1'
          frameborder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        />
      </div>
    </Modal>
  );
};
